// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { UserNotification } from "le-coffre-resources/dist/Notary";
import type { IGetNotificationsParams, IPutNotificationsParams } from "./Notifications";
import { buildNotificationsUpdatePayload } from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

import type { RequestOptions } from "@Front/Api/types";

interface NotificationsInstance {
	get(q?: IGetNotificationsParams, options?: RequestOptions): Promise<UserNotification[]>;
	put(uid: string, body: IPutNotificationsParams): Promise<UserNotification>;
}

// Module-level singleton instance
let instance: NotificationsInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createNotifications(): NotificationsInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/notifications");

	return {
		get: async (q?: IGetNotificationsParams, options?: RequestOptions): Promise<UserNotification[]> => {
			const url = new URL(baseUrl);
			if (q) {
				baseNotary.appendJsonSearchParams(url, { q });
			}
			try {
				return await baseNotary.getRequest<UserNotification[]>(url, options);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
		put: async (uid: string, body: IPutNotificationsParams): Promise<UserNotification> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			try {
				const payload = buildNotificationsUpdatePayload(body);
				return await baseNotary.putRequest<UserNotification>(url, payload);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getNotificationsInstance(): NotificationsInstance {
	if (!instance) {
		instance = createNotifications();
	}
	return instance;
}
